export default () => ({
  el: undefined,
  input: undefined,
  submit: undefined,
  hasSubmit: false,
  init() {
    mrp.log(`RxModalDialogAdvanced init`);
    this.el = this.$el;
    // do we have a match phrase input?
    if (this.$refs.input !== undefined && this.$refs.input !== null) {
      this.input = this.$refs.input;
    }
    // was a child component provided?
    if (
      this.$refs.confirm_container !== undefined &&
      this.$refs.confirm_container !== null
    ) {
      // is there a button to trigger the 'yes' event?
      // we can't make too many assumptions on what the child component
      // of the modal dialog contains, but most likely there is a button
      // to trigger the confirmation action
      this.submit = this.$refs.confirm_container.querySelector("button");
      if (this.submit !== undefined && this.submit !== null) {
        this.hasSubmit = true;
        // disable it
        this.submit.setAttribute("disabled", "");
      }
    }
  },
  validate(evt) {
    if (evt?.target?.value === undefined || evt?.target?.value === null) {
      return;
    }
    // there must be a button to trigger the 'yes' event else there's nothing to do
    if (!this.hasSubmit) {
      return;
    }
    // check that the entered phrase matches the required confirmation phrase
    let matchPhrase = evt.target.getAttribute("data-match-phrase");
    if (matchPhrase === undefined || matchPhrase === null) {
      return;
    }
    if (matchPhrase.toLowerCase() !== evt.target.value.toLowerCase()) {
      // no match so disable
      this.submit.setAttribute("disabled", "");
      return;
    }
    // enable
    this.submit.removeAttribute("disabled");
  },
  dismiss() {
    if (this.hasSubmit) {
      this.submit.setAttribute("disabled", "");
    }
    // clear the input phrase and close the dialog
    this.input.value = "";
    this.el.close();
  },
});
